import React from "react";

const ArrowRight = ({ size = 17, ...rest }) => {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 17 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...rest}
        >
            <g id="arrow-narrow-right">
                <path
                    id="Icon"
                    d="M3.16675 8.81641H13.8334M13.8334 8.81641L9.83341 4.81641M13.8334 8.81641L9.83341 12.8164"
                    stroke="currentColor"
                    fill="currentColor"
                    strokeWidth="1.33"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
        </svg>
    );
};

export default ArrowRight;
